// extracted by mini-css-extract-plugin
module.exports = {"padding-label":"src-_components-___FrequentAddressSearchPanel-module__padding-label___ohpsA","form":"src-_components-___FrequentAddressSearchPanel-module__form___1BfeB"};